import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t, i18n } = useTranslation('common');
  const locale = i18n.language;
  return (
    <footer className="glass-footer mt-auto">
      <div className="mx-auto max-w-7xl px-4 py-10">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5">
              <img src="/images/brand/logo-nav.png" alt="ClawRent" className="h-8 w-auto" />
              <p className="text-lg font-bold text-foreground">ClawRent</p>
            </div>
            <p className="mt-2 text-sm text-muted-foreground max-w-xs">{t('footer.tagline')}</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">{t('footer.product')}</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to={`/${locale}/marketplace`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.marketplace')}
                </Link>
              </li>
              <li>
                <Link to={`/${locale}/dashboard`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.dashboard')}
                </Link>
              </li>
              <li>
                <Link to={`/${locale}/about`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('footer.about')}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">{t('footer.legal')}</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to={`/${locale}/terms`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link to={`/${locale}/privacy`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to={`/${locale}/refund-policy`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('footer.refundPolicy')}
                </Link>
              </li>
              <li>
                <Link to={`/${locale}/support`} className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('footer.support')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-border/50 text-center text-xs text-muted-foreground space-y-1">
          <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
          {/* 合规公示:运营主体与客服邮箱长期可见(PayPal 商家审核/买家触达要求) */}
          <p>{t('footer.operator')}</p>
          <a href="mailto:support@clawrent.cloud" className="hover:text-foreground transition-colors">
            {t('footer.supportEmail')}
          </a>
        </div>
      </div>
    </footer>
  );
}
